import React, { useState, useEffect } from 'react';
import { Power, RefreshCw, Menu } from 'lucide-react';
import { isMarketOpen as checkMarketOpen, getSettings } from '../useSettings';

const EC2_URL = 'https://api.algrok.com';

function useMarketStatus() {
  const [status, setStatus] = useState({ open: false, label: '', time: '', forced: false });
  useEffect(() => {
    const check = () => {
      const now = new Date();
      const istOffset = 5.5 * 60;
      const utc = now.getTime() + now.getTimezoneOffset() * 60000;
      const ist = new Date(utc + istOffset * 60000);
      const timeStr = ist.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      const cfg = getSettings();
      const open = checkMarketOpen();
      const forced = cfg.forceOpen || (cfg.weekendMarketDays?.includes(ist.toISOString().split('T')[0]));
      setStatus({
        open,
        forced,
        label: open ? (forced ? 'OPEN (SPL)' : 'OPEN') : 'CLOSED',
        time: timeStr,
      });
    };
    check();
    const t = setInterval(check, 1000);
    return () => clearInterval(t);
  }, []);
  return status;
}

export default function TopBar({ activePage, onMenuClick, isMobile }) {
  const market = useMarketStatus();
  const [killing, setKilling] = useState(false);
  const [killConfirm, setKillConfirm] = useState(false);

  const handleKill = async () => {
    if (!killConfirm) { setKillConfirm(true); setTimeout(() => setKillConfirm(false), 3000); return; }
    setKilling(true);
    try {
      const r = await fetch(EC2_URL + '/kill', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
      const d = await r.json();
      alert('Kill executed: ' + (d.message || JSON.stringify(d)));
    } catch(e) {
      alert('Kill failed: ' + e.message);
    }
    setKilling(false);
  };

  return (
    <div className="topbar">
      {/* Hamburger for mobile */}
      {isMobile && (
        <button className="topbar-hamburger" onClick={onMenuClick}>
          <Menu size={20} />
        </button>
      )}

      {/* Market status */}
      <div className="market-status">
        <div className={`status-dot ${market.open ? '' : 'closed'}`} />
        <span style={{ color: market.open ? (market.forced ? '#fbbf24' : 'var(--bull)') : 'var(--bear)', fontWeight: 700 }}>
          {market.label}
        </span>
        <span style={{ color: 'var(--text-3)' }}>{market.time}</span>
      </div>

      <div className="topbar-right">
        <button className="topbar-btn" title="Refresh" onClick={() => window.location.reload()}>
          <RefreshCw size={14} />
        </button>
        <button
          className="topbar-btn danger"
          onClick={handleKill}
          disabled={killing}
          style={{ background: killConfirm ? 'rgba(255,68,102,0.4)' : undefined }}>
          <Power size={14} />
          <span>{killing ? '...' : killConfirm ? 'CONFIRM' : 'KILL'}</span>
        </button>
      </div>
    </div>
  );
}
